<template>
  <div>
    <template v-if="status > 0">
      <div v-if="status == 2" class="error">{{ message }}</div>
      <div v-if="status == 3" class="warning">{{ message }}</div>
      <div v-if="status == 1" class="success">{{ message }}</div>
      <br />
      <br />
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted } from "vue";
import { useStatusStore } from "@/stores/root/status";

const statusStore = useStatusStore();
const status = computed(() => {
  return statusStore.status.stat;
});
const message = computed(() => {
  return statusStore.status.msg;
});
onMounted(() => {
  statusStore.clear();
});
</script>
<style scoped>
.error {
  text-align: center;
}
</style>
